<template>
  <div>
    <v-dialog v-model="dialogData" max-width="500px" persistent>
      <v-card>
        <v-form>
          <v-card-title>
            <span class="headline">Transaction Report Detail</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <data-detail-row
                label="Bill Number"
                :data="editedItem"
                :valueData="editedItem.bill_num"
                noGutters
              />
              <data-detail-row
                label="Merchant Name"
                :data="editedItem"
                :valueData="editedItem.merchant_name"
                noGutters
              />
              <data-detail-row
                label="MID"
                :data="editedItem"
                :valueData="editedItem.mid"
                noGutters
              />
              <data-detail-row
                label="Merchant PAN"
                :data="editedItem"
                :valueData="editedItem.mpan"
                noGutters
              />
              <data-detail-row
                label="Reff ID"
                :data="editedItem"
                :valueData="editedItem.rrn"
                noGutters
              />
              <data-detail-row
                label="QR Method"
                :data="editedItem"
                :valueData="editedItem.qr_method"
                noGutters
              />
              <data-detail-row
                label="QR Type"
                :data="editedItem"
                :valueData="editedItem.qr_type"
                noGutters
              />
              <data-detail-row
                label="Transaction Type"
                :data="editedItem"
                :valueData="editedItem.trx_type"
                noGutters
              />
              <data-detail-row
                label="Issuer Name"
                :data="editedItem"
                :valueData="editedItem.issuer_name"
                noGutters
              />
              <data-detail-row
                label="Customer PAN"
                :data="editedItem"
                :valueData="editedItem.customer_pan"
                noGutters
              />
              <data-detail-row
                label="Customer Name"
                :data="editedItem"
                :valueData="editedItem.customer_name"
                noGutters
              />
              <data-detail-row
                label="Payment Type"
                :data="editedItem"
                :valueData="editedItem.payment_type"
                noGutters
              />
              <data-detail-row
                label="Acquirer Name"
                :data="editedItem"
                :valueData="editedItem.payment_channel"
                noGutters
              />
              <data-detail-row
                label="Total Amount"
                :data="editedItem"
                :valueData="editedItem.amount"
                noGutters
              />
              <data-detail-row
                label="Fee"
                :data="editedItem"
                :valueData="editedItem.amount_fee"
                noGutters
              />
              <data-detail-row
                label="MDR"
                :data="editedItem"
                :valueData="editedItem.amount_mdr"
                noGutters
              />
              <data-detail-row
                label="Net Amount"
                :data="editedItem"
                :valueData="editedItem.amount_net"
                noGutters
              />
              <data-detail-row
                label="Transaction Date"
                :data="editedItem"
                :valueData="editedItem.trx_datetime"
                noGutters
              />
              <data-detail-row
                label="Refund Calculation"
                :data="editedItem"
                :valueData="editedItem.refund_calculation"
                noGutters
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
            <v-btn
              color="primary"
              @click="save"
              :disabled="loading"
              :loading="loading"
            >
              Refund
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="400" persistent>
      <notif-dialog
        :icon="'mdi-information'"
        :header="'Refund Gagal'"
        :title="'Silakan coba lagi'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="save"
      />
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { date, showAlert } from '../../lib/helpers';

export default {
  components: {
    notifDialog: () => import('../NotifDialog.vue'),
    DataDetailRow: () => import('../detail/DataDetailRow.vue'),
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogrRf: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  data: () => ({
    dialog: false,
  }),
  computed: {
    dialogData() {
      return this.dialogrRf;
    },
    loading() {
      return this.$store.state.refundInternal.loading;
    },
  },
  methods: {
    cancelDialog() {
      this.$emit('closeCancelParent');
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.$store.commit('refundInternal/setFlashErrorMessage', '');

      await this.$store
        .dispatch('refundInternal/refundData', {
          date,
          id: this.editedItem.id,
          index: this.editedItem.id,
        })
        .then((status) => {
          if (status) {
            this.$emit('clearSelectedParent');
            this.$emit('closeCancelParent');
            this.$emit('fetchDataParent');
            showAlert(
              this.$store,
              'Refund success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            this.dialog = true;
            setTimeout(() => {
              this.dialog = false;
            }, 2000);
          }
        });
    },
  },
};
</script>
